__turbopack_context__.v({
  "bag": "Bag-module__M9Lq8G__bag",
});
